@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

.modal {
  padding: 0;
  width: 576px;

  @include c.containerMedia(v.$tablet-breakpoint) {
    max-width: calc(100% - 30px);
  }
}

.contentBox {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: v.$palette-white;
  box-shadow: v.$shadow-2;
  border-radius: 10px;
  text-align: center;
  padding: 24px;
}

.title {
  margin: 16px 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: v.$palette-gray-900;
  max-width: 400px;
}

.buttons {
  display: flex;
  justify-content: center;
  column-gap: 10px;
}

.deleteButtonLoader {
  margin-left: 10px;
  vertical-align: middle;
}

.icon {
  width: 55px;
  margin: -15px;
}
